/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupOverrides,
  ClassSignupOverridesOptional,
  ClassSignupOverridesMetaI,
  ClassSignupOverridesTrackedI,
} from "./class-signup-overrides";
import {
  ClassSignupOverridesTracked,
  ClassSignupOverridesMeta,
} from "./class-signup-overrides";

/**
 *
 * @export
 * @interface ValidateLineItemOverrides
 */
export interface ValidateLineItemOverridesOptional {
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideValidPeople?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideTypeCheck?: boolean;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof ValidateLineItemOverrides
   */
  ClassSignupOverrides?: ClassSignupOverridesOptional;
}

export interface ValidateLineItemOverrides extends ValidateLineItemOverridesOptional {
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideValidPeople?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideTypeCheck?: boolean;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof ValidateLineItemOverrides
   */
  ClassSignupOverrides?: ClassSignupOverrides;
}

export interface ValidateLineItemOverridesTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideValidPeople?: boolean;
  overrideValidPeopleIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ValidateLineItemOverrides
   */
  overrideTypeCheck?: boolean;
  overrideTypeCheckIsSet: boolean;
  /**
   *
   * @type {ClassSignupOverrides}
   * @memberof ValidateLineItemOverrides
   */
  ClassSignupOverrides?: ClassSignupOverridesTrackedI;
  ClassSignupOverridesIsSet: boolean;
}

transformDatesMap.set(
  "ValidateLineItemOverrides",
  function (model: ValidateLineItemOverrides) {
    const transformDatesClassSignupOverrides = transformDatesMap.get(
      "ClassSignupOverrides",
    );
    if (transformDatesClassSignupOverrides && model.ClassSignupOverrides) {
      transformDatesClassSignupOverrides(model.ClassSignupOverrides);
    }
  },
);

export type ValidateLineItemOverridesMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  overrideValidPeople: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  overrideTypeCheck: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  ClassSignupOverrides: PropertyMeta<ClassSignupOverridesMetaI>;
}>;

export var ValidateLineItemOverridesMeta: ValidateLineItemOverridesMetaI =
  {} as ValidateLineItemOverridesMetaI;
ValidateLineItemOverridesMeta = typeMeta("ValidateLineItemOverrides", {
  overrideValidPeople: propertyMeta(
    "overrideValidPeople",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  overrideTypeCheck: propertyMeta(
    "overrideTypeCheck",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  ClassSignupOverrides: propertyMeta(
    "ClassSignupOverrides",
    false,
    false,
    false,
    ClassSignupOverridesMeta,
  ),
});

const metaI = ValidateLineItemOverridesMeta;

registerMeta(() => {});

export class ValidateLineItemOverridesTracked implements ValidateLineItemOverridesTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  overrideValidPeople__I?: boolean = undefined;
  overrideValidPeopleIsSet: boolean = false;
  set overrideValidPeople(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideValidPeople__I = v;
      this.overrideValidPeopleIsSet = true;
    } else {
      this.overrideValidPeople__I = v || undefined;
      this.overrideValidPeopleIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideValidPeople() {
    return this.overrideValidPeople__I;
  }
  overrideTypeCheck__I?: boolean = undefined;
  overrideTypeCheckIsSet: boolean = false;
  set overrideTypeCheck(v: undefined | boolean) {
    if (v !== undefined) {
      this.overrideTypeCheck__I = v;
      this.overrideTypeCheckIsSet = true;
    } else {
      this.overrideTypeCheck__I = v || undefined;
      this.overrideTypeCheckIsSet = false;
    }
    this.changeTracker = true;
  }
  get overrideTypeCheck() {
    return this.overrideTypeCheck__I;
  }
  ClassSignupOverrides__I?: ClassSignupOverridesTracked = undefined;
  ClassSignupOverridesIsSet: boolean = false;
  set ClassSignupOverrides(v: undefined | ClassSignupOverridesTracked) {
    if (v !== undefined) {
      this.ClassSignupOverrides__I = v;
      this.ClassSignupOverridesIsSet = true;
    } else {
      this.ClassSignupOverrides__I = v || undefined;
      this.ClassSignupOverridesIsSet = false;
    }
    this.changeTracker = true;
  }
  get ClassSignupOverrides() {
    return this.ClassSignupOverrides__I;
  }
  constructor(
    config?: ValidateLineItemOverridesOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.ClassSignupOverrides?.setIds();
  }
  assignFrom(
    config: ValidateLineItemOverridesOptional,
    options?: AssignOptions,
  ): ValidateLineItemOverridesTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.overrideValidPeople &&
      this.overrideValidPeopleApplyFilter(optionsRequired.filter)
    ) {
      this.overrideValidPeople = config.overrideValidPeople;
      if (optionsRequired.unassign) this.overrideValidPeopleIsSet = false;
      else this.overrideValidPeopleIsSet = true;
    }
    if (
      config.overrideTypeCheck &&
      this.overrideTypeCheckApplyFilter(optionsRequired.filter)
    ) {
      this.overrideTypeCheck = config.overrideTypeCheck;
      if (optionsRequired.unassign) this.overrideTypeCheckIsSet = false;
      else this.overrideTypeCheckIsSet = true;
    }
    if (
      config.ClassSignupOverrides &&
      this.ClassSignupOverridesApplyFilter(optionsRequired.filter)
    ) {
      this.ClassSignupOverrides = new ClassSignupOverridesTracked(
        config.ClassSignupOverrides,
        options,
      );
      if (optionsRequired.unassign) this.ClassSignupOverridesIsSet = false;
      else this.ClassSignupOverridesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ValidateLineItemOverridesTrackedI {
    const cloned = {} as ValidateLineItemOverridesTrackedI;
    if (
      this.overrideValidPeopleIsSetDeep() &&
      this.overrideValidPeopleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideValidPeopleIsSet = true;
      cloned.overrideValidPeople = this.overrideValidPeople;
    } else {
      //cloned.overrideValidPeopleIsSet = false
    }
    if (
      this.overrideTypeCheckIsSetDeep() &&
      this.overrideTypeCheckApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.overrideTypeCheckIsSet = true;
      cloned.overrideTypeCheck = this.overrideTypeCheck;
    } else {
      //cloned.overrideTypeCheckIsSet = false
    }
    if (
      this.ClassSignupOverridesIsSetDeep() &&
      this.ClassSignupOverridesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ClassSignupOverridesIsSet = true;
      cloned.ClassSignupOverrides =
        this.ClassSignupOverrides?.removeUnset(filter);
    } else {
      //cloned.ClassSignupOverridesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ValidateLineItemOverridesTrackedI {
    if (!this.overrideValidPeopleApplyFilter(filter))
      this.overrideValidPeopleIsSet = false;

    if (!this.overrideTypeCheckApplyFilter(filter))
      this.overrideTypeCheckIsSet = false;

    if (!this.ClassSignupOverridesApplyFilter(filter))
      this.ClassSignupOverridesIsSet = false;
    this.ClassSignupOverrides?.unassignAll(filter);

    return this;
  }
  overrideValidPeopleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidateLineItemOverridesMeta.overrideValidPeople,
      ValidateLineItemOverridesMeta,
      this.overrideValidPeople,
      this,
    );
  }
  overrideValidPeopleIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideValidPeopleIsSet &&
      this.overrideValidPeopleApplyFilter(filter)
    )
      return true;

    return false;
  }
  overrideTypeCheckApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidateLineItemOverridesMeta.overrideTypeCheck,
      ValidateLineItemOverridesMeta,
      this.overrideTypeCheck,
      this,
    );
  }
  overrideTypeCheckIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.overrideTypeCheckIsSet &&
      this.overrideTypeCheckApplyFilter(filter)
    )
      return true;

    return false;
  }
  ClassSignupOverridesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ValidateLineItemOverridesMeta.ClassSignupOverrides,
      ValidateLineItemOverridesMeta,
      this.ClassSignupOverrides,
      this,
    );
  }
  ClassSignupOverridesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.ClassSignupOverridesIsSet &&
      this.ClassSignupOverridesApplyFilter(filter)
    )
      return true;
    return this.ClassSignupOverrides?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.overrideValidPeopleIsSetDeep(filter)) return true;
    if (this.overrideTypeCheckIsSetDeep(filter)) return true;
    if (this.ClassSignupOverridesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
